import type { CreatorAudienceUploadTarget } from '@/biz/multiPlatformCollaboration/audience';

export const buildAudienceScreenshotRequest = (
  urls: string[],
  target?: CreatorAudienceUploadTarget,
  fallback?: { platform?: string; orderId?: string }
) => {
  if (target?.kind === 'v2') {
    return {
      path: '/influencer/v2/audience/imageLink',
      body: { channelKey: target.channelKey, urls, orderId: target.orderId }
    };
  }

  return {
    path: `/influencer/${target?.platform ?? fallback?.platform}/audience/imageLink`,
    body: { urls, orderId: target?.orderId ?? fallback?.orderId }
  };
};
